import { headerLogoUrl } from '@/shared/assets';
import { ContentColumn, type WidthVariant } from './content-column';
import { HevitonWordmark } from './heviton-wordmark';

interface StandaloneHeaderProps {
  width?: WidthVariant;
}
/** Standalone 표면 헤더(로그인·구독 등) — HEVITON 아이콘 마크 + 워드마크. */
export function StandaloneHeader({ width }: StandaloneHeaderProps) {
  return (
    <ContentColumn as="header" className="pb-12" width={width}>
      <div className="flex items-center gap-2">
        <img src={headerLogoUrl} alt="" className="h-5 w-auto" aria-hidden="true" />
        <HevitonWordmark className="text-foreground w-19" />
      </div>
    </ContentColumn>
  );
}
